import { render, staticRenderFns } from "./SchilkseeBase.vue?vue&type=template&id=7a3b8597"
import script from "./SchilkseeBase.vue?vue&type=script&lang=js"
export * from "./SchilkseeBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports